import { FC } from 'react'
import { Redirect, Route, RouteComponentProps } from 'react-router'

import { useSelector } from '../../store'
import Roles from '../../models/roles'
import { NON_AUTH_ROUTE } from '../../pages/App/routes'
import { SETTING_NAME } from '../../store/project/types'

type PrivateRouteWithLayoutProps = {
  layout: FC
  component: FC<RouteComponentProps>
  path: string
  roles: Roles[]
  exact?: boolean
}

const PrivateRouteWithLayout: FC<PrivateRouteWithLayoutProps> = ({
  component: Component,
  layout: Layout,
  children,
  roles,
  ...rest
}) => {
  const { user, location, currentProject } = useSelector(({ auth: { user }, router: { location }, project:{currentProject}}) => ({
    user,
    location,
    currentProject
  }))

  if (!user || user.is_blocked) {
    return (
      <Redirect
        to={{
          pathname: NON_AUTH_ROUTE.LOGIN,
          state: { from: location.pathname + location.search }
        }}
      />
    )
  }

  return (
    <Route
      {...rest}
      render={(matchProps: any) =>
        roles.includes(user.agency_role) || user.can_create_agency || (!!user?.projects?.find(v=>v.id === currentProject.id)?.setting.find(v=>v.name === SETTING_NAME.CONTENT_MANAGER && v.value === 'true'))? (
          <Layout>
            <Component {...matchProps}>{children}</Component>
          </Layout>
        ) : (
          <Redirect to={NON_AUTH_ROUTE.LOGIN} />
        )
      }
    />
  )
}

export default PrivateRouteWithLayout
